import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchCurrentUser } from '../../API';
import { useEffect } from 'react';

export default function WordSearchConfig() {
    const [inputCount, setInputCount]           = useState('10');
    const [inputDifficulty, setInputDifficulty] = useState('EASY');
    const navigate = useNavigate();

    useEffect(() => {
        fetchCurrentUser().then(user => {
            if (user.logged && !user.profileComplete) {
                navigate('/choose-username');
            }
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        const params = new URLSearchParams({
            count:      inputCount,
            difficulty: inputDifficulty,
        });
       
        navigate(`/wordsearch?${params.toString()}`);
    };

    return (
        <div style={styles.screenWrapper}>
            <div style={styles.card}>
                <div style={styles.header}>
                    <div style={{ fontSize: '40px' }}>🔍</div>
                    <h1 style={styles.title}>Wykreślanka</h1>
                    <p style={styles.subtitle}>Znajdź ukryte słówka w siatce liter.</p>
                </div>

                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Poziom trudności:</label>
                        <select
                            value={inputDifficulty}
                            onChange={e => setInputDifficulty(e.target.value)}
                            style={styles.input}
                        >
                            <option value="EASY">Łatwy</option>
                            <option value="MEDIUM">Średni</option>
                            <option value="HARD">Trudny</option>
                        </select>
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Ilość słów (1–30):</label>
                        <input
                            type="number"
                            min="1"
                            max="30"
                            value={inputCount}
                            onChange={e => setInputCount(e.target.value)}
                            style={styles.input}
                        />
                    </div>
<button type="submit" style={styles.button}>
                        Zacznij naukę
                    </button>
                </form>

               
            </div>
        </div>
    );
}

const styles = {
    screenWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
    },
    card: {
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px',
        padding: '35px',
        boxSizing: 'border-box',
    },
    header: {
        textAlign: 'center',
        marginBottom: '25px',
    },
    title: {
        margin: '8px 0 6px',
        fontSize: '26px',
        color: '#0f172a',
        fontWeight: '800',
    },
    subtitle: {
        margin: 0,
        fontSize: '15px',
        color: '#64748b',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
    },
    label: {
        fontWeight: '600',
        fontSize: '13px',
        color: '#475569',
    },
    input: {
        padding: '12px',
        fontSize: '16px',
        borderRadius: '10px',
        border: '2px solid #e2e8f0',
        backgroundColor: '#f8fafc',
        outline: 'none',
    },
    button: {
        padding: '14px',
        fontSize: '17px',
        fontWeight: 'bold',
        backgroundColor: '#2563eb',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'background 0.2s',
    },
    backBtn: {
        marginTop: '14px',
        width: '100%',
        padding: '11px',
        fontSize: '15px',
        fontWeight: '600',
        backgroundColor: 'transparent',
        color: '#64748b',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'background 0.2s',
    },
};
